<template>
  <div class="station-actions">
    <h2 class="f8">{{ $t("Remote Start Game Launcher") }}</h2>
    <div class="grid">
      <div class="buttongroup">
        <UIButton
          :secondary="true"
          class="launcher"
          @click="launchLauncher()"
        >{{ $t('Start Game Launcher') }}</UIButton>
        <small
          class="helper f7"
        >{{ $t('This will open the 3D environment where a user can then select a game to play. If there is currently a VR game running, it will close that game then return to game launcher.') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    UIButton,
  },
  props: {
    station: {
      type: Object,
      required: true,
    },
  },
})
export default class StationStatus extends Vue {
  launchLauncher () {
    this.$emit('launchLauncher');
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.station-actions {
  & .launcher {
    width: 100%;
  }

  & .grid {
    display: grid;
    grid-gap: var(--spacingSm);

    @media (--tablet) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
